<template>
    <div>
        <transition name="fade" mode="out-in">
            <div :key="0" v-if="loading">
                <div v-if="loading" class="loaderContainer">
                    <dot-loader></dot-loader>
                </div>
            </div>
            <div :key="1" v-else>
                <DashboardFavoriteBar :medium="vuexState.campaign.campaign.mediums[mediumIndex]"></DashboardFavoriteBar>
                <tabs class="tabbar" @tabSelected="changeMediumIndex">
                    <tab v-for="(medium, index) in vuexState.campaign.campaign.mediums"
                         :name="medium.type + ' ' + (medium.name?medium.name:'')"
                         :selected="index === 0" :key="'tab-no-'+index" :device-type="medium.type" :index="index">
                        <transition :key="2" name="fade" mode="out-in">
                            <div v-if="!trackinglistLoading" :style="{height: trackinglistHeight}">
                                <div class="trackinglistWrapper"
                                     v-if="trackingListId">
                                    <div id="trackingHeader">
                                        <div id="generalHeader"
                                             :style="{width: vuexState.trackingList.dashboard.firstColWidth,
                                             minWidth:vuexState.trackingList.dashboard.firstColWidth}">
                                        </div>
                                        <div id="reportingHeader">
                                            <KPIBox v-for="(insertionOrder, i) in insertionOrderOrSites"
                                                    :key="'kpi_'+i"
                                                    :style="i % 2 === 0 ? vuexState.trackingList.kpiStyles.kpi_odd : vuexState.trackingList.kpiStyles.kpi_even"
                                                    :engagementHash="findOriginalInsertionOrder(insertionOrder).engagement_hash">
                                                <InfoBubble color="pink" :is-filled="true" :disabled="true"
                                                            icon="icon-info"
                                                            :iconStyle="vuexState.trackingList.kpiStyles.kpiIcon"
                                                            :iconHover="getSites(findOriginalInsertionOrder(insertionOrder))">
                                                    {{
                                                        insertionOrder.name ? insertionOrder.name : insertionOrder.type
                                                    }}
                                                </InfoBubble>
                                                <InfoBubble color="blue" :is-filled="true" :disabled="true"
                                                            :iconStyle="vuexState.trackingList.kpiStyles.kpiIcon">
                                                    {{
                                                        getFullDate(findOriginalInsertionOrder(insertionOrder))
                                                    }}
                                                </InfoBubble>
                                                <InfoBubble color="white" :is-filled="true" :disabled="true"
                                                            icon="icon-info"
                                                            icon-color="#d0d4da"
                                                            :iconStyle="vuexState.trackingList.kpiStyles.kpiIcon"
                                                            :iconHover="getImpressions(findOriginalInsertionOrder(insertionOrder))">
                                                    {{
                                                        totalAIs(findOriginalInsertionOrder(insertionOrder))
                                                    }}
                                                </InfoBubble>
                                            </KPIBox>
                                        </div>
                                    </div>
                                    <div id="trackinglistContent">
                                        <AdaDatatable style="width:100%; margin-top: 10px"
                                                      :columns="columns"
                                                      :data="[]" :stickyFirstCol="stickyFirstCol"
                                                      :show-search="false"
                                                      @domReady="setTableHeaderWidth"></AdaDatatable>
                                        <SlotAccordion style="margin-top:5px" title="Zusammenfassung"
                                                       :disable-duplicate="true"
                                                       :disable-delete="true"
                                                       :disable-add="true"
                                                       @accordionCollapse="setTrackinglistHeight"
                                                       :sticky="stickyFirstCol" v-if="formulas.length !== 0">
                                            <template v-slot:content>
                                                <div v-if="formulaReady">
                                                    <TrackingRow v-for="(formula, i) in formulas"
                                                                 :key="'formula_'+i+'_'+Math.floor(100000 + Math.random() * 900000)"
                                                                 :data="formula" :showReporting="showReporting"
                                                                 :sticky="stickyFirstCol"
                                                                 type="formula"
                                                                 @rendered="setTrackinglistHeight"
                                                    ></TrackingRow>
                                                </div>
                                            </template>
                                        </SlotAccordion>
                                        <template v-for="(space, index) in spaces">
                                            <SlotAccordion v-bind:key="index + 'tlSpace'"
                                                           :disable-duplicate="true" :disable-delete="true"
                                                           :disable-add="true"
                                                           :sticky="stickyFirstCol" :move-index="index"
                                                           @accordionCollapse="setTrackinglistHeight"
                                                           :title="space.name">
                                                <template v-slot:content>
                                                    <Space :technicalName="space.technical_name"
                                                           :interactions="space.interactions"
                                                           :modules="space.modules" :showReporting="showReporting"
                                                           :sticky="stickyFirstCol"
                                                           :space-index="index" :space="space"
                                                           :showMoveIcons="false"
                                                           :showActions="false"></Space>
                                                </template>
                                            </SlotAccordion>
                                        </template>
                                    </div>
                                </div>
                                <div v-else>Keine Daten.</div>
                            </div>
                            <div :key="3" v-else class="loaderContainer">
                                <dot-loader></dot-loader>
                            </div>
                        </transition>
                    </tab>
                </tabs>
                <DashboardCommentSection :campaign="vuexState.campaign.campaign"
                                         :view="isIntern ? 'intern' : 'extern'"></DashboardCommentSection>
                <DashboardAttachment id="attachment-area"
                                     :medium="vuexState.campaign.campaign.mediums[mediumIndex]"></DashboardAttachment>

            </div>
        </transition>
    </div>
</template>

<script>
import Utils from '../../../scripts/utils';
import Tabs from "../../../components/tablist/basicTabs/Tabs";
import Tab from "../../../components/tablist/basicTabs/Tab";
import KPIBox from "../../../components/kpiBox/KPIBox";
import InfoBubble from "../../../components/inputs/InfoBubble";
import AdaDatatable from "../../../components/tables/AdaDatatable";
import SlotAccordion from "../../../components/accordion/SlotAccordion";
import TrackingRow from "../../trackingList/TrackingRow";
import Space from "../../trackingList/Space";
import DashboardFavoriteBar from "../DashboardFavoriteBar";
import DashboardAttachment from "../DashboardAttachement";
import DashboardCommentSection from "../DashboardCommentSection";
import moment from 'moment';

export default {
    name: "ShowReporting",
    components: {
        DashboardCommentSection,
        DashboardAttachment,
        DashboardFavoriteBar,
        Space,
        TrackingRow,
        SlotAccordion,
        AdaDatatable,
        InfoBubble,
        KPIBox,
        Tab,
        Tabs
    },
    data: function () {
        return {
            mediumIndex: 0,
            trackingRowKey: 0,
            loading: true,
            trackinglistLoading: true,
            stickyFirstCol: true,
            formulaReady: false,
            showReporting: true,
            mediumChangePending: false,
            trackinglistHeight: '100vh',
            textarea: 'loading...',
        }
    },
    beforeRouteEnter(to, from, next) {
        if (typeof to.meta.edited === 'undefined') {
            let meta = to.meta;
            meta.edited = true;
            let query = from.name ? from.query : to.query;
            next({
                path: to.path,
                query: query,
                meta: meta
            })
        } else {
            if (typeof to.meta.edited !== 'undefined') {
                delete to.meta.edited;
            }
            next();
        }
    },
    mounted() {
        this.$store.dispatch('sites/fetchAllAdServer');
        if (this.$route.name === 'showDashboard' || this.$route.name === 'showReporting') {
            this.$store.dispatch('campaign/fetch', this.$route.params.id).then(() => {
                this.textarea = this.vuexState.campaign.campaign.comment;
                this.$store.dispatch('trackingList/fetch', this.trackingListId)
                .then(() => {
                    this.loading = false;
                    this.trackinglistLoading = false;
                    let tt = setInterval(() => {
                        this.setTrackinglistHeight();
                    }, 500);
                    setTimeout(function () {
                        clearInterval(tt);
                    }, 10000);
                    this.$store.dispatch('trackingList/fetchReportings', {vm: this}).then(() => {
                        if (!this.mediumChangePending) {
                            this.formulaReady = true;
                        }

                    });
                });
            });
        } else {
            this.loading = false;
        }
    },
    computed: {
        vuexState() {
            return this.$store.state;
        },
        trackingList() {
            return this.$store.state.trackingList.data;
        },
        trackingListId() {
            return this.vuexState.campaign.campaign.mediums[this.mediumIndex].tracking_list_id;
        },
        medium() {
            return this.vuexState.campaign.campaign.mediums[this.mediumIndex]
        },
        spaces() {
            if (this.isIntern) {
                return this.$store.state.trackingList.data.spaces;
            } else {
                let ret = [];
                this.$store.state.trackingList.data.spaces.forEach((space) => {
                    let tmp = JSON.parse(JSON.stringify(space));
                    tmp.interactions = space.interactions.filter(item => item.visibility === 'extern');
                    for (let i = space.modules.length - 1; i >= 0; i--) {
                        for (let j = space.modules[i].interactions.length - 1; j >= 0; j--) {
                            if (space.modules[i].interactions[j].visibility === 'intern') {
                                space.modules[i].interactions.splice(j, 1);
                            }
                        }
                        if (space.modules[i].interactions.length === 0) {
                            space.modules.splice(i, 1);
                        }
                    }
                    tmp.modules = space.modules;
                    if (tmp.interactions.length !== 0 || tmp.modules.interactions !== 0) {
                        ret.push(tmp);
                    }
                });
                for (let i = ret.length - 1; i >= 0; i--) {
                    if (ret[i].interactions.length === 0 && ret[i].modules.length === 0) {
                        ret.splice(i, 1);
                    }
                }
                return ret;
            }
        },
        formulas() {
            let ret = this.$store.getters['trackingList/formulas'];
            if (ret.findIndex(x => x.name === 'video_sum') !== -1) ret.splice(ret.findIndex(x => x.name === 'video_sum'), 1);
            if (ret.findIndex(x => x.name === 'expand_sum') !== -1) ret.splice(ret.findIndex(x => x.name === 'expand_sum'), 1);
            if (this.isIntern) {
                return ret;
            } else {
                return ret.filter(formula => formula.pivot.visibility === 'extern');
            }
        },
        columns() {
            let ret = [{
                viewName: 'Name',
                propName: 'name',
                width: this.vuexState.trackingList.dashboard.firstColWidth,
                styles: {padding: '9px 0'}
            }];
            let insertionOrders = this.insertionOrderOrSites;
            for (let i = 0; i < insertionOrders.length; i++) {
                ret.push({
                    viewName: 'Anzahl',
                    propName: 'repCount_' + i,
                    width: '85px',
                    styles: {padding: '9px 0'}
                });
                ret.push({
                    viewName: 'Relation zu Gesamt-AIs',
                    propName: 'repRelation_' + i,
                    width: '115px',
                    styles: {padding: '0px 4px 0px 4px', margin: '8px 0px 8px 8px'}
                });
            }
            ret.push({
                viewName: 'Beschreibung',
                propName: 'description',
                width: this.vuexState.trackingList.columns.find(x => x.viewName === 'Beschreibung').width
            });
            return ret;
        },
        isIntern() {
            return typeof this.$route.query.key === 'undefined';
        },
        reporting() {
            return this.$store.getters['trackingList/reporting'];
        },
        insertionOrderOrSites: function () {
            let abbreviations = [
                {name: 'Run of Channel', short: 'RoC'},
                {name: 'Festplatzierung', short: 'FP'},
                {name: 'Run of Site', short: 'RoS'},
            ];
            if (Object.keys(this.reporting).length > 0) {
                let ret = [];
                for (let i = 0; i < this.medium.insertion_order.length; i++) {
                    let insertionOrder = this.medium.insertion_order[i];
                    if (insertionOrder.sites.length === 0 && this.reporting[insertionOrder.engagement_hash + '_' + insertionOrder.id]) {
                        ret.push(insertionOrder);
                        let sites = this.reporting[insertionOrder.engagement_hash + '_' + insertionOrder.id].sites;
                        for (let j = 0; j < Object.keys(sites).length; j++) {
                            let site = this.$store.state.sites.sites.find(x => x.code === Object.keys(sites)[j]);
                            if (typeof site === 'undefined') {
                                console.log('couldn\'t find site with code', Object.keys(sites)[j]);
                            } else {
                                let tmp = {
                                    id: insertionOrder.id,
                                    notOG: true,
                                    sites: [site],
                                    type: (site ? site.name : Object.keys(sites)[j]) + ' ' + abbreviations.find(x => x.name === insertionOrder.type).short,
                                };
                                ret.push(tmp);
                            }

                        }
                    }else if(insertionOrder.sites.length > 0){
                        ret.push(insertionOrder);
                    }
                }
                return ret;
            } else {
                return this.medium.insertion_order;
            }
        },
    },
    methods: {
        changeMediumIndex(mediumIndex) {
            this.mediumChangePending = true;
            this.mediumIndex = mediumIndex;
            this.fetchTrackingList();
            this.trackingRowKey++;
        },
        getFullDate: function (insertionOrder) {
            let dateArr = insertionOrder.dates;
            if ((this.$route.name === 'showDashboard' || this.$route.name === 'showReporting') && typeof insertionOrder.dashboard_dates !== 'undefined' && insertionOrder.dashboard_dates.length > 0) {
                dateArr = insertionOrder.dashboard_dates;
            }
            let start = dateArr[0].start;
            let end = dateArr[0].end;
            for (let i = 0; i < dateArr.length; i++) {
                if (dateArr[i].start < start) {
                    start = dateArr[i].start;
                }
                if (dateArr[i].end > end) {
                    end = dateArr[i].end;
                }
            }
            return this.formatDate(start) + ' - ' + this.formatDate(end);
        },
        formatDate(dateStr) {
            return moment(dateStr, 'YYYY-MM-DD').format('DD.MM.YY');
        },
        totalAIs(insertionOrder) {
            /*let reporting = this.$store.getters['trackingList/reporting'];
            if (typeof reporting[insertionOrder.engagement_hash] === "undefined") {
                return '...';
            } else {*/
            return Utils.calcImpressions(insertionOrder.line_items, this.trackingList.medium.type).totalAIs.toLocaleString('de-DE') + ' AIs';
            //}
        },
        getSites(insertionOrder) {
            let ret = [];
            for (let i = 0; i < insertionOrder.sites.length; i++) {
                if (insertionOrder.sites[i].parent_code) {
                    ret.push(insertionOrder.sites[i].parent_name + ' - ' + insertionOrder.sites[i].name);
                } else {
                    ret.push(insertionOrder.sites[i].name);
                }
            }
            return ret.join(', <br>')
        },
        twoDigitize(number) {
            return ("0" + number).slice(-2);
        },
        setTrackinglistHeight() {
            window.requestAnimationFrame(() => {
                let trackinglistWrapper = document.querySelectorAll('.trackinglistWrapper')[this.mediumIndex];
                if (trackinglistWrapper && trackinglistWrapper.getBoundingClientRect().height !== 0) {
                    this.trackinglistHeight = (trackinglistWrapper.getBoundingClientRect().height) + 'px';
                }
            });
        },
        setTableHeaderWidth() {
            document.getElementById('trackinglistContent').firstElementChild.style.width = "100%";
        },
        fetchTrackingList() {
            this.formulaReady = false;
            this.trackinglistLoading = true;
            this.$store.dispatch('trackingList/fetch', this.trackingListId)
            .then(() => {
                this.trackinglistLoading = false;
                let tt = setInterval(() => {
                    this.setTrackinglistHeight();
                }, 500);
                setTimeout(function () {
                    clearInterval(tt);
                }, 10000);
                if (this.trackingListId === null) {
                    this.trackinglistHeight = '100px';
                }
                this.$store.dispatch('trackingList/fetchReportings', {vm: this}).then(() => {
                    this.mediumChangePending = false;
                    this.formulaReady = true;
                });
            });
        },
        getImpressions(insertionOrder) {
            let ret = [];
            let impressions = Utils.calcImpressions(insertionOrder.notOG ? this.findOriginalInsertionOrder(insertionOrder).line_items : insertionOrder.line_items, this.medium.type);
            if (impressions.desktopAIs !== 0 || this.medium.type.toLowerCase() === "online" || this.medium.type.toLowerCase() === "desktop") {
                ret.push('Desktop: ' + impressions.desktopAIs.toLocaleString('de-DE') + ' AIs');
            }
            if (impressions.tabletAIs !== 0 || this.medium.type.toLowerCase() === "online" || this.medium.type.toLowerCase() === "tablet") {
                ret.push('Tablet: ' + impressions.tabletAIs.toLocaleString('de-DE') + ' AIs');
            }
            if (impressions.mobileAIs !== 0 || this.medium.type.toLowerCase() === "mobile") {
                ret.push('Mobile: ' + impressions.mobileAIs.toLocaleString('de-DE') + ' AIs');
            }
            return ret.join('<br>');
        },
        findOriginalInsertionOrder(insertionOrder) {
            if (typeof insertionOrder.notOG !== "undefined" && insertionOrder.notOG) {
                let originals = this.insertionOrderOrSites.filter(x => typeof x.notOG === "undefined");
                return originals.find(x => x.id === insertionOrder.id);
            } else {
                return insertionOrder;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
#trackingHeader {
    height: 100px;
    display: flex;
    flex-flow: row;
    background: #fff;
}

#generalHeader {
    background: white;
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-flow: row;
    align-items: flex-end;
    padding: 1em;
    width: 100%;
}

#reportingHeader {
    display: flex;
    flex-flow: row;
}

.loaderContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 10em;
}

.trackinglistWrapper {
    position: absolute;
    left: 0;
    width: 100%;
    overflow-x: auto;
}

::v-deep .ada-table {
    .table-header-row {
        display: flex;
        align-items: center;

        > th {
            float: left;
        }
    }

    .table-header {
        cursor: default;
    }
}

#attachment-area {
    margin-top: 20px;
}

.tabbar {
    margin-top: -5.25em;
    margin-bottom: 3.2em;
}

@media only screen and (max-width: 767px) {
    .tabbar {
        margin-top: -4em;
        width: 100vw;
        margin-left: -1rem;
    }
}

@media (min-width: 768px) and (max-width: 1024px) {
    .tabbar {
        margin-top: -4em;
        // width: 100vw;
    }
}

@media (min-width: 1025px) and (max-width: 1199px) {
    .tabbar {
        margin-top: -4.3em;
        // width: 100vw;
    }
}
</style>